module.exports = __webpack_public_path__ + "img/about_1.b3b9819e.png";